import { Phone } from "lucide-react";
import { useContactSettings } from "@/hooks/useContactSettings";

export default function WhatsAppButton() {
  const { getWhatsAppLink } = useContactSettings();

  return (
    <a
      href={`${getWhatsAppLink()}?text=السلام عليكم، أريد الاستفسار عن خدماتكم`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 left-6 z-50 flex items-center gap-2 px-4 py-3 rounded-full bg-green-600 shadow-lg text-white hover:scale-105 transition-transform"
      aria-label="تواصل عبر واتساب"
    >
      <Phone className="h-5 w-5" />
      <span className="text-sm font-bold hidden sm:inline">واتساب</span>
    </a>
  );
}
